var render = function render(_c,_vm){return _c('div',{staticClass:"card-text"},[_c('a',{staticClass:"forced-pointer-events-auto",attrs:{"href":_vm.props.value,"target":"_blank","rel":"nofollow noopener noreferrer"},on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.props.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }